/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PatientEnrollment.css';

import ContentHeader from 'legacy/containers/ContentHeader';
import PatientSearchForm from '../../components/PatientSearchForm';
import EnrolledPatientResultTable from '../../components/EnrolledPatientResultTable';
import PatientEnrollmentForm from '../../containers/PatientEnrollmentForm';
import { clearAllData } from '../../state/PatientEnrollment/PatientEnrollmentActions';
import EcgLoader from 'legacy/containers/EcgLoader';
// Route: patient/enroll-patient

// PatientEnrollment Page Container
//     patient search form
//     Enrolled patient redult table
//     Patient enrollment form ( container - has 2 modes edit and new) - validation function for child components'.
//         patient profile form component
//         insurance form component
//         Study enrollment form component
//         Physician and Practice info component

const PatientEnrollment = () => {
  const dispatch = useDispatch();
  const me = useSelector(state => state.app.dataSources.me);
  const isEnrolledData = useSelector(
    state =>
      state.idtfPatientEnrollment.patientEnrollment.isFetchingEnrolledData,
  );
  const patientEnrollemtFormShow = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.showPatientForm,
  );
  const showResultScreen = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.showResultScreen,
  );
  const enrollEditMode = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.enrollEditMode,
  );
  useEffect(() => {
    dispatch(clearAllData());
  }, []);

  return (
    <div className={styles.Page}>
      <ContentHeader
        isLoading={me.isFetching}
        showAddPatient={false}
        enableBackButton={false}
        showLastRefresh={false}
        isFullWidth={true}
        text="Enroll Patient"
        me={me}
      />
      {
        <div className={styles.PageContainer}>
          <div style={{textAlign: 'end', marginRight: '32px', height: '10px'}}>
          <span className={styles.required}>* </span> <span> Required Field</span>
          </div>
          {!(patientEnrollemtFormShow && !enrollEditMode) ? <PatientSearchForm /> : ''}
          {isEnrolledData ? <EcgLoader /> :
          patientEnrollemtFormShow ? <PatientEnrollmentForm me={me} /> : showResultScreen ? <EnrolledPatientResultTable /> : ''
          }
        </div>
      }
    </div>
  );
};

export default PatientEnrollment;



// WEBPACK FOOTER //
// ./src/views/pages/PatientEnrollment/PatientEnrollment.jsx